const transformCrmCustomerRewardBalanceMeResponse = ({ points_balance , pts_to_amount_rate_pts , pts_to_amount_rate_amount  })=>({
        points: parseInt(points_balance),
        currencyPoints: parseFloat(points_balance / pts_to_amount_rate_pts * pts_to_amount_rate_amount),
        ptsToAmountRatePts: pts_to_amount_rate_pts,
        ptsToAmountRateAmount: pts_to_amount_rate_amount
    });
const transformHistory = ({ created_at , message , points_delta , expiration_date  })=>({
        createdAt: created_at,
        message,
        pointsDelta: parseInt(points_delta),
        expirationDate: expiration_date
    });
const transformCustomerRewardHistoryMeResponse = (data)=>data.map((history)=>transformHistory(history));
const transformSalesCartRewardBalanceMeResponse = ({ quote_applied_code , potential_earning_points , pts_to_amount_rate_pts , pts_to_amount_rate_amount  })=>({
        currentThreshold: parseInt(quote_applied_code),
        earningPoints: parseInt(potential_earning_points),
        currencyEarningPoints: parseFloat(potential_earning_points / pts_to_amount_rate_pts * pts_to_amount_rate_amount)
    });
const transformSalesCartRewardThresholdMeResponse = (data)=>data.map(({ threshold_points_mapping_code , threshold_points_mapping_points_to_apply  })=>({
            code: parseInt(threshold_points_mapping_code),
            points: parseInt(threshold_points_mapping_points_to_apply)
        }));
const transformCrmCustomerRewardSubscriptionMeResponse = ({ reward_warning_notification , reward_update_notification  })=>({
        warningNotification: parseInt(reward_warning_notification),
        updateNotification: parseInt(reward_update_notification)
    });
const transformPutCrmCustomerRewardSubscriptionMeResponse = (data)=>transformCrmCustomerRewardSubscriptionMeResponse(data);
const transformDeleteSalesCartReward = ()=>true;
const transformPostSalesCartRewardResponse = ()=>true;

export { transformCrmCustomerRewardBalanceMeResponse, transformCrmCustomerRewardSubscriptionMeResponse, transformCustomerRewardHistoryMeResponse, transformDeleteSalesCartReward, transformPostSalesCartRewardResponse, transformPutCrmCustomerRewardSubscriptionMeResponse, transformSalesCartRewardBalanceMeResponse, transformSalesCartRewardThresholdMeResponse };
